/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Error_Dialog_TitleInputs */



/**
* | output |
* | --- |
* | "Problem with BMS modules" |
*
* @param {Live_Error_Dialog_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const live_error_dialog_title = /** @type {((inputs?: Live_Error_Dialog_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Error_Dialog_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Problem with BMS modules")
	return /** @type {LocalizedString} */ ("Problème avec les modules GTB")
});